import React from 'react';
import { Card, Row, Col } from 'antd';
import SlaStatusChart from './SlaStatusChart';
import './TicketOverview.css';
import OpenTicketsByDepartment from './OpenTicketsByDepartment';

export default function TicketOverview({ overViewData }) {
  return (
    <div className='ticket-overview-container'>
      <Row gutter={[0, 16]}>
        <Col span={24} style={{ padding: '16px 0 0 0' }}>
          <Card
            className='urgent-tickets-card'
            style={{
              backgroundColor: '#AF0000',
              border: 'none',
              borderRadius: '16px',
              margin: '0',
            }}
          >
            <div className='ticket-stat'>
              <div
                className='stat-number'
                style={{ color: '#fff', fontSize: '28px', fontWeight: 700 }}
              >
                {overViewData.urgentTicketCount}
              </div>
              <div
                className='stat-label'
                style={{ color: '#fff', fontSize: '14px', fontWeight: 400 }}
              >
                Urgent Tickets
              </div>
            </div>
          </Card>
        </Col>

        <Col span={24} style={{ padding: '16px 0 0 0' }}>
          <Card
            className='resolution-time-card'
            style={{ borderRadius: '16px', margin: '0' }}
          >
            <div className='ticket-stat'>
              <div
                className='stat-number'
                style={{ color: '#000', fontSize: '28px', fontWeight: 500 }}
              >
                {overViewData.avgResolutionTime}
              </div>
              <div
                className='stat-label'
                style={{ color: '#858585', fontSize: '14px', fontWeight: 400 }}
              >
                Average Resolution Time
              </div>
            </div>
          </Card>
        </Col>

        <Col span={24} style={{ padding: '16px 0 0 0' }}>
          <Card
            className='sla-status-card'
            title='SLA Status'
            size='small'
            style={{ margin: '0' }}
          >
            <SlaStatusChart overViewData={overViewData.slaStatusDistribution} />
          </Card>
        </Col>
        <Col span={24} style={{ padding: '16px 0 0 0' }}>
          <OpenTicketsByDepartment
            overViewData={overViewData.openTicketsByDepartment}
          />
        </Col>
      </Row>
    </div>
  );
}
